export const bzAgendaSessions = [
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3022177,
                "role": "Moderator"
            },
            {
                "speakerId": 3010617
            },
            {
                "speakerId": 3010616
            },
            {
                "speakerId": 3010613
            }
        ],
        "externalId": "rNZzyJZstwNOw",
        "title": "Looking Local First - An Approach that Integrates Saudi Culture, Talent and Local Supply Chain into the Brand and Business Model",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 720,
        "endMinute": 750,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1120695
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 2994090,
                "role": "Moderator"
            },
            {
                "speakerId": 3013668
            },
            {
                "speakerId": 2993340
            },
            {
                "speakerId": 3020248
            },
            {
                "speakerId": 3011953
            }
        ],
        "externalId": "TBvM75zLQPRPH",
        "title": "Founders’ Chat: Driving Growth and Generating Value in the Business Through Own Concepts.  What Mechanisms Can You Use to Finance Expansion while still Retaining Control?  ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 570,
        "endMinute": 600,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1120737
    },
    {
        "filters": [
            {
                "id": 64995,
                "tags": [
                    388115,
                    389592,
                    394512
                ]
            }
        ],
        "description": "At the Mansard Riyadh, the delegates will experience the grandeur of French-inspired architecture combined with Arabian hospitality as they walk through the hotel's beautiful plaza, lined with Parisian-named buildings - all of which will be decorated with subtle hints of blue and beige to create a calming and timeless atmosphere.\n\nThe reception will offer a variety of international and Arabic dishes, with food carts and beverage bars set up as street vendors. The live food stations will be styled as food carts or storefronts, and waiters will offer tray-passed welcome drinks, dates, and Saudi coffee upon arrival. \n\nThroughout the evening, the atmosphere will be enhanced by ambient music from a house musician, a laser display with alternating logos and quotes from notable people in the field, and classic movies projected on the walls of the villas.",
        "private": false,
        "externalId": "IhwuVCN8uOzRF",
        "title": "Networking Reception at Mansard Riyadh, a Radisson Collection Hotel hosted by Radisson Hotel Group",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 1110,
        "endMinute": 1290,
        "descriptionHtml": "<p>At the Mansard Riyadh, the delegates will experience the grandeur of French-inspired architecture combined with Arabian hospitality as they walk through the hotel's beautiful plaza, lined with Parisian-named buildings - all of which will be decorated with subtle hints of blue and beige to create a calming and timeless atmosphere.</p><p>The reception will offer a variety of international and Arabic dishes, with food carts and beverage bars set up as street vendors. The live food stations will be styled as food carts or storefronts, and waiters will offer tray-passed welcome drinks, dates, and Saudi coffee upon arrival.&nbsp;</p><p>Throughout the evening, the atmosphere will be enhanced by ambient music from a house musician, a laser display with alternating logos and quotes from notable people in the field, and classic movies projected on the walls of the villas.</p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1105867
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    403736
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592,
                    401200
                ]
            }
        ],
        "description": "With over 500K+ keys in the region and over 1M Keys opening within MEA in the next 5+ yrs there is a paradigm shift in the way we look at asset management as a business and as a vertical. There is a stronger focus on pre-opening along with all the other aspects being and not limited to budgets, HMAs, Salary Scales, Sustainability/Regenerative Goals, FF&E and OS&E procurement, Human Capital Goals (both local and international), as well as operational synergies, are all front and center topics. \n\nHotel/Hospitality Asset Managers find themselves in one of the most unique pre-opening conditions our trade has ever witnessed. The round table focuses on some of the key learnings along with a open conversation with fellow asset managers with current need of the business to future proof it within the region.\n\n\n",
        "private": false,
        "speakers": [
            {
                "speakerId": 2990176
            },
            {
                "speakerId": 3025984
            }
        ],
        "externalId": "4Yl3Av3gUiGXW",
        "title": "Closed Door HAMA MEA Saudi Arabia Round Table – ‘The Great Pre-Opening’ ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 990,
        "endMinute": 1050,
        "descriptionHtml": "<p>With over 500K+ keys in the region and over 1M Keys opening within MEA in the next 5+ yrs there is a paradigm shift in the way we look at asset management as a business and as a vertical. There is a stronger focus on pre-opening along with all the other aspects being and not limited to budgets, HMAs, Salary Scales, Sustainability/Regenerative Goals, FF&amp;E and OS&amp;E procurement, Human Capital Goals (both local and international), as well as operational synergies, are all front and center topics.&nbsp;</p><p>Hotel/Hospitality Asset Managers find themselves in one of the most unique pre-opening conditions our trade has ever witnessed. The round table focuses on some of the key learnings along with a open conversation with fellow asset managers with current need of the business to future proof it within the region.</p><p><br></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-07T00:00:00.000+0000",
        "endDate": "2023-05-07T23:59:59.000+0000",
        "id": 1134948
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2994090,
                "role": "Moderator"
            },
            {
                "speakerId": 2994091
            },
            {
                "speakerId": 3022174
            },
            {
                "speakerId": 2993342
            },
            {
                "speakerId": 3010610
            }
        ],
        "externalId": "nQSbQG1WNaouk",
        "title": "Bringing Globally Successful Contemporary Concepts to Saudi Arabia. How Do You Set Up to Ensure You are Contributing to Creating a Flourishing Culinary Culture in Saudi and Engaging a Strong Saudi Work Force?",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 780,
        "endMinute": 810,
        "descriptionHtml": "<p><a href=\"https://youtu.be/9RpoTMtQJKY\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1131567
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3002021,
                "role": "Moderator"
            },
            {
                "speakerId": 3010599
            }
        ],
        "externalId": "uMsOZLXK6ejGy",
        "title": " Founder’s Chat: Sinan Al Saady, Founder & CEO of Cool Inc on Building A New Business Model - Rich Data and Local Customer Insights to Curate What’s Cool in Saudi Arabia",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 810,
        "endMinute": 825,
        "descriptionHtml": "<p><a href=\"https://youtu.be/yeN2zUUjDmI\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1120675
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2975516,
                "role": "Moderator"
            },
            {
                "speakerId": 3007868
            },
            {
                "speakerId": 3005898
            },
            {
                "speakerId": 3034970
            },
            {
                "speakerId": 3036807
            },
            {
                "speakerId": 3037045
            },
            {
                "speakerId": 3034972
            }
        ],
        "externalId": "y4OoXZVAa12Km",
        "title": "How can Saudi Arabia’s Sustainability Vision be Turned to Reality on the Ground? The Giga-projects are Setting the Pace, But How do We Ensure all Constituencies Buy-in and Benefit, Including the Private Sector? ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 915,
        "endMinute": 960,
        "descriptionHtml": "<p><a href=\"https://youtu.be/V6dTwTewD4Q\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1119909
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2995096,
                "role": "Moderator"
            },
            {
                "speakerId": 2995082
            }
        ],
        "externalId": "JPRXqqK4ew2vM",
        "title": "Introduction to One of 'The Largest Hospitality Projects In The World' Followed by an Announcement and  Signing Ceremony",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 960,
        "endMinute": 980,
        "descriptionHtml": "<p><a href=\"https://youtu.be/i2uu4TPERiw\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1105864
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2977557,
                "role": "Moderator"
            },
            {
                "speakerId": 3007896
            },
            {
                "speakerId": 2996887
            },
            {
                "speakerId": 2996890
            }
        ],
        "externalId": "oDdC3qI3sVyY6",
        "title": "Case Study - Private and Public Sector Collaborate to Accelerate Lifestyle Developments and Promote New Destinations #Vision2030",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 670,
        "endMinute": 700,
        "descriptionHtml": "<p><a href=\"https://youtu.be/xwMJjdTpwJM\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1105874
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "private": false,
        "externalId": "kVRajCuluvyGr",
        "title": "FHS Networking Coffee Break",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 645,
        "endMinute": 660,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1066876
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3016858
            }
        ],
        "externalId": "GzbqJxhCCtp4w",
        "title": "A Deep Dive into the Hotel Development Pipeline from Contracts Signed, Construction to Opening",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 585,
        "endMinute": 600,
        "descriptionHtml": "<p><a href=\"https://youtu.be/fbiy5K-O21U\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1128557
    },
    {
        "filters": [
            {
                "id": 64995,
                "tags": [
                    388115,
                    389592,
                    394512
                ]
            }
        ],
        "description": "Please be advised that all culinary tours are now at capacity and you need a confirmation email to attend.\n\n\n\n\nLPM Riyadh hosted by Nicolas Budzynski, Chief Executive Officer, LPM Restaurant & Bar\n\nMeraki hosted by Sanjay Dwivedi, Chef Patron & Culinary Director and Olivier Eynard, Co-Founder, Meraki\n\nThe Brasserie hosted by Marcel Kofler, Director of Operations, Al Faisaliah Hotel  \n\nMAMO Michelangelo Riyadh hosted by Tunji Olapido, MAMO Chef\n\nYauatcha hosted by Mehmet Safa Sihlaroglu, General Manager, Yauatcha Riyadh\n\n\n\n\nView Culinary Tours Highlights Online.\n\nFor more information about GRIF visit - futurehospitality.com/sa/grif\n\n\n\n\n\n\n\n\n\n\n\n",
        "private": false,
        "speakers": [
            {
                "speakerId": 2994091
            },
            {
                "speakerId": 2993342
            },
            {
                "speakerId": 3010566
            },
            {
                "speakerId": 3038235
            },
            {
                "speakerId": 3010571
            },
            {
                "speakerId": 3010572
            }
        ],
        "externalId": "jl2s7TE6OOJ0h",
        "title": "GRIF Culinary Tours Summary",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 720,
        "endMinute": 945,
        "descriptionHtml": "<p><span style=\"color: rgb(147, 101, 184);\"><strong>Please be advised that all culinary tours are now at capacity and you need a confirmation email to attend.</strong></span></p><p><br></p><p><strong>LPM Riyadh&nbsp;</strong>hosted by <strong>Nicolas Budzynski</strong>, Chief Executive Officer, LPM Restaurant &amp; Bar</p><p><strong>Meraki</strong> hosted by <strong>Sanjay Dwivedi</strong>, Chef Patron &amp; Culinary Director and <strong>Olivier Eynard</strong>, Co-Founder, Meraki</p><p><strong>The Brasserie&nbsp;</strong>hosted by<strong>&nbsp;Marcel Kofler</strong>, Director of Operations, Al Faisaliah Hotel &nbsp;</p><p><strong>MAMO Michelangelo Riyadh</strong> hosted by <strong>Tunji Olapido</strong>, MAMO Chef</p><p><strong>Yauatcha</strong> hosted by <strong>Mehmet Safa Sihlaroglu</strong>, General Manager, Yauatcha Riyadh</p><p><br></p><p><a href=\"https://youtu.be/LgbpdurdZMw\" rel=\"noopener noreferrer\" target=\"_blank\">View Culinary Tours Highlights Online.</a></p><p><em>For more information about GRIF visit -&nbsp;</em><a href=\"https://www.futurehospitality.com/sa/grif\"><em>futurehospitality.com/sa/grif</em></a></p><p><br></p><p><br></p><p><br></p><p><br></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-07T00:00:00.000+0000",
        "endDate": "2023-05-07T23:59:59.000+0000",
        "id": 1130780
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "What else can the industry do to encourage the next generation of talent?\n\nClick here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3022159,
                "role": "Moderator"
            },
            {
                "speakerId": 3013667
            }
        ],
        "externalId": "AuMCbLkRWRVQF",
        "title": "How is the Saudi Restaurant and Food Scene Developing? What is the Impact of Shows like Top Chef on Encouraging Saudis going into Hospitality and Promoting It as a Career?",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 650,
        "endMinute": 670,
        "descriptionHtml": "<p>What else can the industry do to encourage the next generation of talent?</p><p><a href=\"https://youtu.be/46I6CaAd8os\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1131554
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3010820
            }
        ],
        "externalId": "4P90XKSUPP63p",
        "title": "Sustainability in Action in Saudi Arabia - What Actionable Measures Can be Taken to Create Less Waste and Environmental Impact?",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 880,
        "endMinute": 900,
        "descriptionHtml": "<p><a href=\"https://youtu.be/dzM3OtxmifM\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1120700
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3015097,
                "role": "Moderator"
            },
            {
                "speakerId": 2949740
            },
            {
                "speakerId": 2975494
            },
            {
                "speakerId": 3024110
            },
            {
                "speakerId": 3023944
            }
        ],
        "externalId": "v3FR3nH2fQEqp",
        "title": "The Power of Collaboration from Original Concept Design, Modern Methods of Construction to Opening",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 890,
        "endMinute": 930,
        "descriptionHtml": "<p><a href=\"https://youtu.be/nmKFLPwrTVU\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1129192
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3020037
            },
            {
                "speakerId": 3032732
            }
        ],
        "externalId": "WEXzCr2F9X5VY",
        "title": "‘Space: A New Tourism Frontier?’ ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 1030,
        "endMinute": 1060,
        "descriptionHtml": "<p><a href=\"https://youtu.be/XfvePJj9OsA\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1129275
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "Where does she see the opportunities in the market? What needs to happen to continue to facilitate the continued development of the restaurant sector towards Vision 2030?\n\nClick here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3002021,
                "role": "Moderator"
            },
            {
                "speakerId": 3010604
            }
        ],
        "externalId": "I3svZm9f8jjPE",
        "title": "Founder’s Chat: Deem Albassam, Co-founder & Managing Director of The Independent Food Company in conversation with Simon Wright, Founder & Chairman, TGP International  on the Development and Growth of Saudi’s Food Scene. ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 570,
        "endMinute": 585,
        "descriptionHtml": "<p>Where does she see the opportunities in the market? What needs to happen to continue to facilitate the continued development of the restaurant sector towards Vision 2030?</p><p><a href=\"https://youtu.be/W6XZqRg7psE\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1120678
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3005892,
                "role": "Moderator"
            },
            {
                "speakerId": 3019241
            },
            {
                "speakerId": 3020152
            }
        ],
        "externalId": "EGfhDIKMSd3BO",
        "title": "Connecting Saudi to the World and Enabling Vision 2030",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 680,
        "endMinute": 700,
        "descriptionHtml": "<p><a href=\"https://youtu.be/IRURRmNdTZY\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1105818
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2949742,
                "role": "Moderator"
            },
            {
                "speakerId": 2906051
            },
            {
                "speakerId": 3018944
            }
        ],
        "externalId": "0mXqOWPUWCD0P",
        "title": "Activating Innovation, Acceleration and Investment in the Hospitality Industry",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 750,
        "endMinute": 780,
        "descriptionHtml": "<p><a href=\"https://youtu.be/T5o52cxt1UI\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1105879
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Creating lasting impacts on the entire leisure and hospitality industry, properties will need to adapt to survive in this new marketplace, but how?\n\nClick here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3019256,
                "role": "Moderator"
            },
            {
                "speakerId": 3024123
            },
            {
                "speakerId": 3024129
            },
            {
                "speakerId": 2901611
            }
        ],
        "externalId": "NziLmrdOknuZF",
        "title": "The Future of Leisure",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 950,
        "endMinute": 980,
        "descriptionHtml": "<p>Creating lasting impacts on the entire leisure and hospitality industry, properties will need to adapt to survive in this new marketplace, but how?</p><p><a href=\"https://youtu.be/85V4x6L7VCg\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1129204
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3032268
            }
        ],
        "externalId": "ekRqN5zQ0vICP",
        "title": "Welcome Back",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 540,
        "endMinute": 555,
        "descriptionHtml": "<p><a href=\"https://youtu.be/mT9GaP3o2BI\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1144558
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 2993341
            },
            {
                "speakerId": 2993343
            },
            {
                "speakerId": 3034964
            }
        ],
        "externalId": "GJBeee2NkM3Lf",
        "title": "Bringing an International Franchise Brand to KSA: How to Choose the Right Brand and Negotiate the Best Deal",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 695,
        "endMinute": 720,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1145421
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "View Online:\n\nOpening Remarks by Jonathan Worsley\n\nOpening Remarks by HH Prince Bandar bin Saud bin Khalid Al Saud",
        "private": false,
        "speakers": [
            {
                "speakerId": 2990242
            },
            {
                "speakerId": 2960705
            }
        ],
        "externalId": "9KaJA6QeCAG6F",
        "title": "Welcome to The Future Hospitality Summit and Opening Remarks ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 660,
        "endMinute": 680,
        "descriptionHtml": "<p>View Online:</p><p><a href=\"https://youtu.be/dQ1GLkbyKtI\" rel=\"noopener noreferrer\" target=\"_blank\">Opening Remarks by Jonathan Worsley</a></p><p><a href=\"https://youtu.be/fNUX7xNgI0I\" rel=\"noopener noreferrer\" target=\"_blank\">Opening Remarks by HH Prince Bandar bin Saud bin Khalid Al Saud</a></p>",
        "locationId": 60851,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1066871
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2995096
            }
        ],
        "externalId": "pME7kiQKU1oeF",
        "title": "Welcome FHS Intelligence Talks",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 550,
        "endMinute": 555,
        "descriptionHtml": "<p><a href=\"https://youtu.be/KAN5vBbq4CI\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1141267
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2909765,
                "role": "Moderator"
            },
            {
                "speakerId": 2901602
            },
            {
                "speakerId": 2996908
            },
            {
                "speakerId": 2902560
            },
            {
                "speakerId": 2901886
            }
        ],
        "externalId": "V7tD0EqeUiqHs",
        "title": "Industry Leaders Share Their Insight on How They Are 'Investing in Change'? ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 700,
        "endMinute": 740,
        "descriptionHtml": "<p><a href=\"https://youtu.be/TjBz8M5l-9s\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1105820
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3007294,
                "role": "Moderator"
            },
            {
                "speakerId": 2998953
            },
            {
                "speakerId": 2901605
            },
            {
                "speakerId": 2901666
            }
        ],
        "externalId": "YvTAlHakiu6Kc",
        "title": "The Reinvention of Commercial Spaces – How Hotels, Retail and F&B are Merging and Bringing Added Value to Customers and Owners",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 830,
        "endMinute": 860,
        "descriptionHtml": "<p><a href=\"https://youtu.be/Uu--cZnBHP0\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "locationId": 60851,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1105908
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2908330,
                "role": "Moderator"
            },
            {
                "speakerId": 3026511
            },
            {
                "speakerId": 2994226
            }
        ],
        "externalId": "y4wuUROrfM7t3",
        "title": "Creating Dining Destinations: 'The Importance of the Right Location and Creating a Partnership Between Tenant and Landlord that Work for both Parties'",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 855,
        "endMinute": 880,
        "descriptionHtml": "<p><a href=\"https://youtu.be/5HZgdB9InFg\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1137612
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2995096,
                "role": "Moderator"
            },
            {
                "speakerId": 3015375,
                "role": ""
            },
            {
                "speakerId": 3038661
            }
        ],
        "externalId": "RewT5FQpV38dN",
        "title": "The Return of Chinese Outbound Travellers and their Influence on the Future of Tourism ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 900,
        "endMinute": 930,
        "descriptionHtml": "<p><a href=\"https://youtu.be/qYeT39r3ns0\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1105863
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3009525,
                "role": "Moderator"
            },
            {
                "speakerId": 3023027
            }
        ],
        "externalId": "8hoVgib8bxQcF",
        "title": "The Smart City - The Future of Living, Work and Play",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 810,
        "endMinute": 830,
        "descriptionHtml": "<p><a href=\"https://youtu.be/_6zTB10YZsk\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1132329
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2949741,
                "role": "Moderator"
            },
            {
                "speakerId": 3039416
            },
            {
                "speakerId": 2996894
            },
            {
                "speakerId": 2975492
            },
            {
                "speakerId": 3007852
            }
        ],
        "externalId": "9PG8upkg0Zzye",
        "title": "How Brands are Supporting Development of the Saudi Hospitality Market and Catering to the Domestic Market",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 600,
        "endMinute": 640,
        "descriptionHtml": "<p><a href=\"https://youtu.be/8xWNHh50GA8\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1105872
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2909765,
                "role": "Moderator"
            },
            {
                "speakerId": 2998979
            },
            {
                "speakerId": 3039925
            }
        ],
        "externalId": "x0hCFkDVqEvFd",
        "title": "The Saudi Private Sector and Vision 2030",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 870,
        "endMinute": 890,
        "descriptionHtml": "<p><a href=\"https://youtu.be/TK-g_zpfBUY\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1129189
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "How I Love Poke leveraged technology, supply chain integration and put the right systems in place to grow into a $60million revenue business in five years.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2993343
            }
        ],
        "externalId": "GZOHcIE6fTYTd",
        "title": "Case Study: Creating a Scalable and Franchise-able Brand in One of Europe’s Toughest Markets",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 645,
        "endMinute": 660,
        "descriptionHtml": "<p>How I Love Poke leveraged technology, supply chain integration and put the right systems in place to grow into a $60million revenue business in five years.</p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1120747
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "private": false,
        "externalId": "MqPlyzZ9MYI9y",
        "title": "GRIF Networking Coffee Break",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 660,
        "endMinute": 680,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1131632
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496,
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "private": false,
        "externalId": "nTtRkrc2tYi4J",
        "title": "FHS Networking Lunch",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 790,
        "endMinute": 840,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1066920
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "What is filtering into the Saudi market and what should we expect to see in the future? What are the trends we are seeing emanating from the Saudi market?\n\nClick here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3002021
            }
        ],
        "externalId": "rf8VDiIqC4AUO",
        "title": "GRIF Exclusive Intelligence - Looking at Global Trends in Eating Out ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 550,
        "endMinute": 570,
        "descriptionHtml": "<p>What is filtering into the Saudi market and what should we expect to see in the future? What are the trends we are seeing emanating from the Saudi market?</p><p><a href=\"https://youtu.be/kKkGk1Iq-H0\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1120668
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2953849
            }
        ],
        "externalId": "JEpZXCu3sfqTe",
        "title": "Global Challenges & Market Resilience, KSA Vision 2030 & Government Initiatives",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 555,
        "endMinute": 570,
        "descriptionHtml": "<p><a href=\"https://youtu.be/2vOjjorh984\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1108935
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2901604,
                "role": "Moderator"
            },
            {
                "speakerId": 2950637
            },
            {
                "speakerId": 2960871
            },
            {
                "speakerId": 3010467
            },
            {
                "speakerId": 2957378
            }
        ],
        "externalId": "5Gcg5HMwJkceT",
        "title": "The Business of Luxury and Wellness in a Changing World",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 860,
        "endMinute": 900,
        "descriptionHtml": "<p><a href=\"https://youtu.be/yRRvzuEAEPs\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1105861
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2976520,
                "role": "Moderator"
            },
            {
                "speakerId": 2990561
            },
            {
                "speakerId": 2994243
            },
            {
                "speakerId": 2994242
            },
            {
                "speakerId": 3024119
            }
        ],
        "externalId": "73Lk3N6nPhq9J",
        "title": "Branded Residential - From Challenging Areas Such as Rental Pools and Residence Associations to Making the Project Viable in Saudi ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 750,
        "endMinute": 795,
        "descriptionHtml": "<p><a href=\"https://youtu.be/vQckQ-V9edY\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1119914
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    399370
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3034964
            }
        ],
        "externalId": "tYhu3smPzZX3J",
        "title": "A Health and Wellness Policy is as Important as Your Health and Safety Policy. Some of us Have One, but How Well Do We Defend it from the ‘Always On’ Culture?",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 930,
        "endMinute": 950,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1144643
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3002023,
                "role": "Moderator"
            },
            {
                "speakerId": 3029149
            },
            {
                "speakerId": 3023060
            },
            {
                "speakerId": 3024876
            }
        ],
        "externalId": "Xweoad6k9YmP7",
        "title": "Finding the Right Partners and Formulating the Right Agreement - What Does it Take to Form the Right Agreement and Working Partnership to Generate Meaningful ROI and Longevity? ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 615,
        "endMinute": 645,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1120744
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "private": false,
        "externalId": "o3Jk5ngcGzSaQ",
        "title": "GRIF Networking Lunch",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 720,
        "endMinute": 780,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1131631
    },
    {
        "filters": [
            {
                "id": 64995,
                "tags": [
                    389592,
                    394512
                ]
            }
        ],
        "description": "Please be advised that all tours are now at capacity and you need a confirmation email to attend.",
        "private": false,
        "externalId": "mknDBKzCeiZBO",
        "title": "Site tour to At-Turaif, Diriyah Gate",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 1035,
        "endMinute": 1230,
        "descriptionHtml": "<p><span style=\"color: rgb(147, 101, 184);\"><strong>Please be advised that all tours are now at capacity and you need a confirmation email to attend.</strong></span></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1122225
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "private": false,
        "externalId": "BgdXHc1MivBca",
        "title": "FHS Networking Coffee Break",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 930,
        "endMinute": 960,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1066894
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115,
                    401200
                ]
            }
        ],
        "description": "What You Need to do to Prepare Your Business to Enter the Saudi Market – Understanding the Regulations, Landscape and Consumers\n\n•Jana Bader, General Manager KSA, The Bench\n\n•Gregory L. Black, Chief Executive Officer, BBG Developments\n•Wentzel David de Wet, General Manager, KSA Shobak, Kitopi\n•Mohammed Subedar, Founder & MD, SBD Alliance\n\n\n\nBuilding a Sustainable and Collaborative Ecosystem: Strengthening the Relationship between the Restaurant and Agricultural Industries in Saudi Arabia\n\n•Duncan Fraser-Smith, Founder Cutting Edge; Author, Create to Plate\n•Andrew Morrow, Founder/Consultant,  Tomorrow Hospitality\n•Abdullah Shokair, Marketing Manager, Bather Farm\n\n\n\nBringing an International Franchise Brand to KSA: How to Choose the Right Brand and Negotiate the Best Deal\n\n•Rebecca Viani, Partner, Head of International Development & Franchising Advisory, White Space Partners\n•Dr Rana Edwards, CEO & Founder, I Love\n•Ramakrishnan Ranganathan, Chief Financial Officer, Abdulla Al Othaim Investment Company\n\n",
        "private": false,
        "speakers": [
            {
                "speakerId": 2908330
            },
            {
                "speakerId": 2994087
            },
            {
                "speakerId": 3039105
            },
            {
                "speakerId": 3010639
            },
            {
                "speakerId": 3023373
            },
            {
                "speakerId": 3029191
            },
            {
                "speakerId": 3031036
            },
            {
                "speakerId": 2993341
            },
            {
                "speakerId": 2993343
            },
            {
                "speakerId": 3033111
            }
        ],
        "externalId": "NGyv1zLwxsMNc",
        "title": "Kitchen Table Chats - Session  2 - Interactive Sessions Led by Experts which Encourage Questions and Sharing of Knowledge by All Those Attending",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 980,
        "endMinute": 1020,
        "descriptionHtml": "<p><strong>What You Need to do to Prepare Your Business to Enter the Saudi Market – Understanding the Regulations, Landscape and Consumers</strong></p><ul><li><strong>Jana Bader</strong>, General Manager KSA, The Bench<strong><br></strong></li><li><strong>Gregory L. Blac</strong><strong>k</strong>, Chief Executive Officer, BBG Developments</li><li><strong>Wentzel David de Wet</strong>, General Manager, KSA Shobak, Kitopi</li><li><strong>Mohammed Subedar</strong>, Founder &amp; MD, SBD Alliance</li></ul><p><br></p><p><strong>Building a Sustainable and Collaborative Ecosystem: Strengthening the Relationship between the Restaurant and Agricultural Industries in Saudi Arabia</strong></p><ul><li><strong>Duncan Fraser-Smith</strong>, Founder Cutting Edge; Author, Create to Plate</li><li><strong>Andrew Morrow</strong>, Founder/Consultant, &nbsp;Tomorrow Hospitality</li><li><strong>Abdullah Shokair</strong>, Marketing Manager, Bather Farm</li></ul><p><br></p><p><strong>Bringing an International Franchise Brand to KSA: How to Choose the Right Brand and Negotiate the Best Deal</strong></p><ul><li><strong>Rebecca Viani</strong>, Partner, Head of International Development &amp; Franchising Advisory, White Space Partners</li><li><strong>Dr Rana Edwards</strong>, CEO &amp; Founder, I Love</li><li><strong>Ramakrishnan Ranganathan</strong>, Chief Financial Officer, Abdulla Al Othaim Investment Company</li></ul><p><br></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1141257
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2919529
            }
        ],
        "externalId": "BCqvqyy6rK6Md",
        "title": "Hotel Performance Trends - Supply & Demand Dynamics",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 570,
        "endMinute": 585,
        "descriptionHtml": "<p><a href=\"https://youtu.be/rlh7yMG_6y8\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1128556
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3034162,
                "role": "Moderator"
            },
            {
                "speakerId": 2993346
            }
        ],
        "externalId": "LIwWa4hIWwUBn",
        "title": "One-on-one with Tom Aikens, Michelin Star Chef & International Restaurateur and Owner / Director of Cawston Limited on How to Create Hotel Restaurants that Work and Growing Talent in the Hospitality Industry in conversation with Nick van Marken, Managing Director, van Marken Consulting",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 630,
        "endMinute": 650,
        "descriptionHtml": "<p><a href=\"https://youtu.be/GLkC0KrOBFs\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1120698
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3009525,
                "role": "Moderator"
            },
            {
                "speakerId": 3001169
            },
            {
                "speakerId": 3024078
            },
            {
                "speakerId": 3015989
            },
            {
                "speakerId": 3018552
            }
        ],
        "externalId": "V16OGzAskDkWs",
        "title": "Mid-Market Hotels: Meeting the Needs of the Next Generation of Saudi Travelers and the Key to Higher Returns for Owners",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 1020,
        "endMinute": 1065,
        "descriptionHtml": "<p><a href=\"https://youtu.be/Y4ioTozZkuE\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1119915
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "private": false,
        "externalId": "qiinWdy3AJkO5",
        "title": "FHS Networking Coffee Break",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 640,
        "endMinute": 670,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1066914
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    403736
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592,
                    399371
                ]
            }
        ],
        "description": "This conversation will be bringing together behind closed doors influential leaders of the private and government sector such as Mahmoud Abdulhadi (Deputy Minister, Investment Attraction Ministry of Tourism of Saudi Arabia) , Tariq Ali al-Tamimi (Chairman of Al Tamimi),  Norah Al Tamimi (Co-Founder AWN), Marloes Knippenberg (CEO Kerten Hospitality), members of the Seven Entertainment team, attendance of Saudi Cruises supported by the destination Yanbu. Destinations are not built, they are discovered and Yanbu has all the ingredients to turn into the gateway to the Red Sea. \n\nAn accessible City with state of the art infrastructure, a laid back character and serene coastal views.\n\n \n\n\n",
        "private": false,
        "speakers": [
            {
                "speakerId": 3037680,
                "role": "Moderator"
            },
            {
                "speakerId": 3007896
            },
            {
                "speakerId": 3037685
            },
            {
                "speakerId": 3037686
            },
            {
                "speakerId": 2977557
            }
        ],
        "externalId": "WbBQw7lJ5Sofi",
        "title": "Closed Door - Yanbu reimagined: a private round table on Destination evolution presented by AWN and Kerten Hospitality, hosted by Abdulrahman Al Bassam (CEO AWN).",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 570,
        "endMinute": 660,
        "descriptionHtml": "<p>This conversation will be bringing together behind closed doors influential leaders of the private and government sector such as Mahmoud Abdulhadi (Deputy Minister, Investment Attraction Ministry of Tourism of Saudi Arabia) , Tariq Ali al-Tamimi (Chairman of Al Tamimi), &nbsp;Norah Al Tamimi (Co-Founder AWN), Marloes Knippenberg (CEO Kerten Hospitality), members of the Seven Entertainment team, attendance of Saudi Cruises supported by the destination Yanbu. Destinations are not built, they are discovered and Yanbu has all the ingredients to turn into the gateway to the Red Sea.&nbsp;</p><p>An accessible City with state of the art infrastructure, a laid back character and serene coastal views.</p><p>&nbsp;</p><p><br></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1143729
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3009527
            }
        ],
        "externalId": "6Aglru0GK0RbI",
        "title": "Key Trends in Hotel Management Contracts (HMAs)",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 630,
        "endMinute": 645,
        "descriptionHtml": "<p><a href=\"https://youtu.be/F4VxpjNjp5s\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1128561
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "Looking at different models including valuations and turn over rents.\n\nClick here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3010713
            }
        ],
        "externalId": "SAk8FPukkZpdA",
        "title": "GRIF Intelligence: Looking at the  Data. Why Food Halls Make Sense to Drive Growth in Saudi and How to Create Deliver Success for all Stakeholders Including the Consumer?  ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 685,
        "endMinute": 700,
        "descriptionHtml": "<p>Looking at different models including valuations and turn over rents.</p><p><a href=\"https://youtu.be/JEsWFT61Puw\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1120775
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2901606,
                "role": "Moderator"
            },
            {
                "speakerId": 2901607
            },
            {
                "speakerId": 3013238
            },
            {
                "speakerId": 3024868
            }
        ],
        "externalId": "I2TtU3XlHUijI",
        "title": "Is Your Brand Future Sensing WEB3 and the Metaverse?  How the Third Interaction of the Internet Looks Set to Impact the Hospitality Industry and Investment?",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 995,
        "endMinute": 1030,
        "descriptionHtml": "<p><a href=\"https://youtu.be/Y-95OiXw2MQ\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1105866
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2908330,
                "role": "Moderator"
            },
            {
                "speakerId": 3000644
            },
            {
                "speakerId": 3036234
            }
        ],
        "externalId": "OD83GhsE1WDOX",
        "title": "Exploring Strategic Partnerships Opportunities in Alignment with Saudi Arabia's Vision 2030",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 580,
        "endMinute": 600,
        "descriptionHtml": "<p><a href=\"https://youtu.be/o7F_l1_WDCk\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1105870
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Leveraging the strengths of the traditional Najd, Hijazi, and Assiri architecture against the push for Saudi to be seen as a futuristic powerhouse.\n\nClick here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3019238,
                "role": "Moderator"
            },
            {
                "speakerId": 3036803
            },
            {
                "speakerId": 2901609
            }
        ],
        "externalId": "ENRXpWKUFL82h",
        "title": " How Do We Differentiate the Saudi Tourism Product from the Global Competition ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 840,
        "endMinute": 870,
        "descriptionHtml": "<p>Leveraging the strengths of the traditional Najd, Hijazi, and Assiri architecture against the push for Saudi to be seen as a futuristic powerhouse.</p><p><a href=\"https://youtu.be/NuqlIO8-J94\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1129183
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2990242
            }
        ],
        "externalId": "2e0EzZTN0IujH",
        "title": "Announcements & Closing Remarks",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 975,
        "endMinute": 990,
        "descriptionHtml": "<p><a href=\"https://youtu.be/dOo9VIq_958\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1119917
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3036805,
                "role": "Moderator"
            },
            {
                "speakerId": 3036804
            }
        ],
        "externalId": "x3m17r3xst7kP",
        "title": "Fresh Perspectives on Tourism",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 930,
        "endMinute": 950,
        "descriptionHtml": "<p><a href=\"https://youtu.be/B1I0MiEZAe0\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1142669
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    399370
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592,
                    399371
                ]
            }
        ],
        "description": "If you have that new and dynamic brand, you have the chance to pitch your brand to FHS delegates.\n\nRegister on www.futurehospitalitysummit.com/sa/battle-of-the-brands\n\n\n\n\nJudges:\n\nRabih Feghali, Board Member, Hospitality Asset Manager's Association MEA\n\nDavid Keen, Founder & CEO, QUO\n\nJonathan Worsley, Chairman & CEO, The Bench\n\n\n",
        "private": false,
        "speakers": [
            {
                "speakerId": 2990176
            },
            {
                "speakerId": 3005897
            },
            {
                "speakerId": 2990242
            },
            {
                "speakerId": 3031369
            },
            {
                "speakerId": 3031366
            },
            {
                "speakerId": 3031364
            },
            {
                "speakerId": 3039005
            },
            {
                "speakerId": 3031367
            },
            {
                "speakerId": 3036809
            },
            {
                "speakerId": 3039004
            }
        ],
        "externalId": "qMHp2tM0GWo1M",
        "title": "Battle of the Brands",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 570,
        "endMinute": 630,
        "descriptionHtml": "<p>If you have that new and dynamic brand, you have the chance to pitch your brand to FHS delegates.</p><p>Register on <a href=\"https://www.futurehospitalitysummit.com/sa/battle-of-the-brands\">www.futurehospitalitysummit.com/sa/battle-of-the-brands</a></p><p><br></p><p><strong>Judges:</strong></p><p><strong>Rabih Feghali</strong>, Board Member, Hospitality Asset Manager's Association MEA</p><p><strong>David Keen</strong>, Founder &amp; CEO, QUO</p><p><strong>Jonathan Worsley</strong>, Chairman &amp; CEO, The Bench</p><p><br></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1133824
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115,
                    401200
                ]
            }
        ],
        "description": "Uncovering the Key Drivers of Staff Engagement and Retention in the Saudi Restaurant Scene\n\n•Duncan Fraser-Smith, Founder, Cutting Edge; Author, Create to Plate\n•Sheila King, Business Development Manager, Mapal\n•Niccolo Kosarew, Director, Villa Mamas\n•Andrew Morrow, Founder/Consultant,  Tomorrow Hospitality \n\n\n\nBringing an International Franchise Brand to KSA: How to Choose the Right Brand and Negotiate the Best Deal\n\n•Rebecca Viani, Partner, Head of International Development & Franchising Advisory, White Space Partners\n•Dr Rana Edwards, CEO & Founder, I Love\n•Ramakrishnan Ranganathan, Chief Financial Officer, Abdulla Al Othaim Investment Company\n\n\n\n\n",
        "private": false,
        "speakers": [
            {
                "speakerId": 3023373
            },
            {
                "speakerId": 3032321
            },
            {
                "speakerId": 3034740
            },
            {
                "speakerId": 3029191
            },
            {
                "speakerId": 2993341
            },
            {
                "speakerId": 2993343
            },
            {
                "speakerId": 3033111
            }
        ],
        "externalId": "Pxi6zt1bsGS8S",
        "title": "Kitchen Table Chats - Session 1 -  Interactive Sessions Led by Experts which Encourage Questions and Sharing of Knowledge by All Those Attending",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 930,
        "endMinute": 975,
        "descriptionHtml": "<p><strong>Uncovering the Key Drivers of Staff Engagement and Retention in the Saudi Restaurant Scene</strong></p><ul><li><strong>Duncan Fraser-Smith</strong>, Founder, Cutting Edge; Author, Create to Plate</li><li><strong>Sheila King</strong>, Business Development Manager, Mapal</li><li><strong>Niccolo Kosarew</strong>, Director, Villa Mamas</li><li><strong>Andrew Morrow</strong>, Founder/Consultant, &nbsp;Tomorrow Hospitality&nbsp;</li></ul><p><br></p><p><strong>Bringing an International Franchise Brand to KSA: How to Choose the Right Brand and Negotiate the Best Deal</strong></p><ul><li><strong>Rebecca Viani</strong>, Partner, Head of International Development &amp; Franchising Advisory, White Space Partners</li><li><strong>Dr Rana Edwards</strong>, CEO &amp; Founder, I Love</li><li><strong>Ramakrishnan Ranganathan</strong>, Chief Financial Officer, Abdulla Al Othaim Investment Company</li></ul><p><br></p><p><br></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1120731
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    403737
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115,
                    389592
                ]
            }
        ],
        "description": "Speed Networking is a great way to break the ice and ensure you go into FHS already knowing your fellow attendees. Meet over 30 new contacts before the conference has officially started! Don't forget to bring lots of business cards!  Taking place in the Al Omsiat Ballroom B prior to the Opening Reception",
        "private": false,
        "externalId": "Hg7NrBWRrr2gH",
        "title": "FHS Networking Card Exchange",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 1050,
        "endMinute": 1110,
        "descriptionHtml": "<p>Speed Networking is a great way to break the ice and ensure you go into FHS already knowing your fellow attendees. Meet over 30 new contacts before the conference has officially started! Don't forget to bring lots of business cards! &nbsp;Taking place in the Al Omsiat Ballroom B prior to the Opening Reception</p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-07T00:00:00.000+0000",
        "endDate": "2023-05-07T23:59:59.000+0000",
        "id": 1133438
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3002021,
                "role": "Moderator"
            },
            {
                "speakerId": 3029152
            }
        ],
        "externalId": "GO13MyTOJIBlt",
        "title": "Faisal Shaker, Co-founder & CEO, Modern Food Company (MFC) on What He Looks For from Brands and How He is Driving the Growth and Development of MFC.  Where Does He View the Opportunities in the Sector? ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 555,
        "endMinute": 570,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1137611
    },
    {
        "filters": [
            {
                "id": 64995,
                "tags": [
                    388115,
                    389592
                ]
            }
        ],
        "description": " ",
        "private": false,
        "externalId": "IZUaUnMlc3i6K",
        "title": "Registration Opens at Prince Sultan Ballroom",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 960,
        "endMinute": 1140,
        "descriptionHtml": "<p>&nbsp;</p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-07T00:00:00.000+0000",
        "endDate": "2023-05-07T23:59:59.000+0000",
        "id": 1108233
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "Building a brand and strategy for growth; How homegrown QSR brand Pickl has evolved into Yolk and driven growth through acquisition. What is the strategy moving forward?",
        "private": false,
        "speakers": [
            {
                "speakerId": 3034964,
                "role": "Moderator"
            },
            {
                "speakerId": 3010703
            }
        ],
        "externalId": "1RURgvNhnadyc",
        "title": "Founder’s Insights: Moving from an F&B Brand into an F&B Group",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 680,
        "endMinute": 695,
        "descriptionHtml": "<p>Building a brand and strategy for growth; How homegrown QSR brand Pickl has evolved into Yolk and driven growth through acquisition. What is the strategy moving forward?</p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1120765
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2994090
            },
            {
                "speakerId": 2994092
            }
        ],
        "externalId": "HPnKVuC3zc1mJ",
        "title": "Welcome to Global Restaurant Investment Forum (GRIF)",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 540,
        "endMinute": 550,
        "descriptionHtml": "<a href=\"https://youtu.be/xN2tSWqFY8w\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1120667
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "Click here to watch online.\n\n\n",
        "private": false,
        "speakers": [
            {
                "speakerId": 3010592,
                "role": "Moderator"
            },
            {
                "speakerId": 3029148
            },
            {
                "speakerId": 3015369
            },
            {
                "speakerId": 3010595
            }
        ],
        "externalId": "KVZpIYxxlFFnh",
        "title": "Follow on Discussion: Will KSA Follow other Markets or Carve out its Own Unique Path of Growth? ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 600,
        "endMinute": 630,
        "descriptionHtml": "<p><a href=\"https://youtu.be/wsOOAC1caaQ\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p><p><br></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1120672
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3030098
            }
        ],
        "externalId": "O6WypT7DKNiGY",
        "title": "GRIF Intelligence:  How Can Data Drive F&B Decision-Making - Tracking the Behaviour of  Riyadh's High End Diners Around the World",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 670,
        "endMinute": 685,
        "descriptionHtml": "<p><a href=\"https://youtu.be/ZCVj5Tzj4og\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1141252
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3009526,
                "role": "Moderator"
            },
            {
                "speakerId": 3010462
            },
            {
                "speakerId": 3010463
            },
            {
                "speakerId": 3010465
            },
            {
                "speakerId": 3009835
            }
        ],
        "externalId": "8J6l4Djn1i3xj",
        "title": "Key Issues for Owners and Operators to Consider in their HMA's to Avoid Reflagging and Disputes Down the Road ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 975,
        "endMinute": 1020,
        "descriptionHtml": "<p><a href=\"https://youtu.be/zSldv3KYeEw\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1119913
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2990633,
                "role": "Moderator"
            },
            {
                "speakerId": 2990846
            },
            {
                "speakerId": 3011809
            },
            {
                "speakerId": 3001123
            }
        ],
        "externalId": "nk2zt63IG9T8N",
        "title": "Case Study of a Lifestyle Fund in the Kingdom",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 720,
        "endMinute": 750,
        "descriptionHtml": "<p><a href=\"https://youtu.be/9FZt0P3AjvM\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1105884
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2909080
            },
            {
                "speakerId": 2909103
            }
        ],
        "externalId": "V3yeiFQwNxTot",
        "title": "The Evolution of Investing in Holistic Hospitality",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 700,
        "endMinute": 720,
        "descriptionHtml": "<p><a href=\"https://youtu.be/vblX6jg8c6A\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1105878
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2949741,
                "role": "Moderator"
            },
            {
                "speakerId": 3008480
            },
            {
                "speakerId": 2996920
            },
            {
                "speakerId": 2904090
            },
            {
                "speakerId": 2977439
            },
            {
                "speakerId": 2998241
            },
            {
                "speakerId": 2901608
            }
        ],
        "externalId": "OBFWWyKEwV6hQ",
        "title": "How to Motivate The Next Generation of Employees and Where to Educate Them and What are Sources for Talent Acquisition",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 880,
        "endMinute": 930,
        "descriptionHtml": "<p><a href=\"https://youtu.be/52l1iPRgvKE\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1119916
    },
    {
        "private": false,
        "externalId": "4zOB7VoTUOzzK",
        "title": "Registration Opens at Prince Sultan Grand Hall",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 480,
        "endMinute": 600,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1105816
    },
    {
        "filters": [
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "private": false,
        "externalId": "0Hk7WQKTIJVqI",
        "title": "FHS Networking Lunch",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 760,
        "endMinute": 810,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1066880
    },
    {
        "filters": [
            {
                "id": 64995,
                "tags": [
                    388115,
                    389592,
                    394512
                ]
            }
        ],
        "description": "Join us at the opening reception of FHS Saudi Arabia, kindly hosted by our host sponsor Al Khozama, at the luxurious Al Faisaliah Hotel on the evening of May 7th.\n\nExperience a night of elegance and sophistication as you take in the stunning views and opulent ambiance of the hotel, all while indulging in a delectable spread of cuisine and enjoying live music.",
        "private": false,
        "externalId": "fynfu5cbBAs4T",
        "title": "Welcome Reception - Hosted By Al Khozama",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 1110,
        "endMinute": 1230,
        "descriptionHtml": "<p>Join us at the opening reception of FHS Saudi Arabia, kindly hosted by our host sponsor Al Khozama, at the luxurious Al Faisaliah Hotel on the evening of May 7th.</p><p>Experience a night of elegance and sophistication as you take in the stunning views and opulent ambiance of the hotel, all while indulging in a delectable spread of cuisine and enjoying live music.</p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-07T00:00:00.000+0000",
        "endDate": "2023-05-07T23:59:59.000+0000",
        "id": 1066869
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "Is the recent development of the KSA dining-out market matching what Saudis really want?",
        "private": false,
        "speakers": [
            {
                "speakerId": 3002023
            }
        ],
        "externalId": "Ok5nNR6GJNh55",
        "title": "GRIF Exclusive Intelligence - Surge or Certainty?",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 585,
        "endMinute": 600,
        "descriptionHtml": "<p>Is the recent development of the KSA dining-out market matching what Saudis really want?</p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1120670
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    399370
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Judges:\n\n\n\n\nAbdulsalam Alkuwaity, Founder & CEO, SEA Ventures \n\nAmir Amidi, Managing Partner, Travel and Hospitality Center of Innovation, Plug and Play\n\nGuy Hutchinson, President & CEO, Rotana\n\n\n",
        "private": false,
        "speakers": [
            {
                "speakerId": 2906051
            },
            {
                "speakerId": 2949742
            },
            {
                "speakerId": 3018944
            },
            {
                "speakerId": 3026756
            },
            {
                "speakerId": 3026767
            },
            {
                "speakerId": 3026751
            },
            {
                "speakerId": 3026753
            },
            {
                "speakerId": 3026755
            },
            {
                "speakerId": 3026750
            },
            {
                "speakerId": 3026747
            },
            {
                "speakerId": 3022177
            },
            {
                "speakerId": 3026773
            },
            {
                "speakerId": 3026772
            }
        ],
        "externalId": "jy59lW3OrYXjJ",
        "title": "Startup Den Pitches",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 990,
        "endMinute": 1080,
        "descriptionHtml": "<p><strong>Judges:</strong></p><p><br></p><p><strong>Abdulsalam Alkuwaity</strong>, Founder &amp; CEO, SEA Ventures&nbsp;</p><p><strong>Amir Amidi</strong>, Managing Partner, Travel and Hospitality Center of Innovation, Plug and Play</p><p><strong>Guy Hutchinson</strong>, President &amp; CEO, Rotana</p><p><br></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1134894
    },
    {
        "filters": [
            {
                "id": 64995,
                "tags": [
                    388115,
                    394512
                ]
            }
        ],
        "description": "Please be advised that all culinary tours are now at capacity and you need a confirmation email to attend.\n\n\n\n\nMaiz – hosted by Cladys Magagna, Corporate Director, Food and Beverage, Al Khozama\n\nVilla Mama – hosted by Roaya Saleh, Founder, Villa Mama and President & Founder, RS Management WLL\n\nAltopiano – hosted by Dr. Aljuhara Aljuhaimi, Owner, Altopiano\n\n\n",
        "private": false,
        "speakers": [
            {
                "speakerId": 3010638
            },
            {
                "speakerId": 3010610
            },
            {
                "speakerId": 3010617
            }
        ],
        "externalId": "YB4JnsFa1LAky",
        "title": "Departure for Culinary Tours of GCC-born Concepts at Bujairi Terrace, Diriyah Gate",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 765,
        "endMinute": 990,
        "descriptionHtml": "<p><span style=\"color: rgb(147, 101, 184);\"><strong>Please be advised that all culinary tours are now at capacity and you need a confirmation email to attend.</strong></span></p><p><br></p><p><strong>Maiz – hosted by Cladys Magagna</strong>, Corporate Director, Food and Beverage, Al Khozama</p><p><strong>Villa Mama – hosted by Roaya Saleh</strong>, Founder, Villa Mama and President &amp; Founder, RS Management WLL</p><p><strong>Altopiano – hosted by Dr. Aljuhara Aljuhaimi</strong>, Owner, Altopiano</p><p><br></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1105885
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 2994090,
                "role": "Moderator"
            },
            {
                "speakerId": 2994086
            }
        ],
        "externalId": "CglxppXFjCUbT",
        "title": "Case Study: Taking Middle East Brands into the International Market – Building an International Portfolio to Diversify Risk and Leverage Brand Positioning",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 600,
        "endMinute": 615,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1120742
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "private": false,
        "externalId": "rnF0MWjkmCNml",
        "title": "Welcome Back & Opening Remarks",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 570,
        "endMinute": 580,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1105869
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3018537
            }
        ],
        "externalId": "Rf5RdjIlOi1pY",
        "title": "Staffing Accommodation - Supply & Demand Dynamics ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 615,
        "endMinute": 630,
        "descriptionHtml": "<p><a href=\"https://youtu.be/Las6l5EhCD0\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1128559
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3015097
            }
        ],
        "externalId": "H6i8OzjKrC3oW",
        "title": "Key Construction Costs in the Kingdom",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 600,
        "endMinute": 615,
        "descriptionHtml": "<a href=\"https://youtu.be/olwB0TxpFx0\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1128558
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2994090
            }
        ],
        "externalId": "JthvDk7I3qyVu",
        "title": "How are Robotics & Technology Defining the Future of Restaurants?",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 700,
        "endMinute": 720,
        "descriptionHtml": "<p><a href=\"https://youtu.be/NVvV2OrnFiM\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1144644
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3005892,
                "role": "Moderator"
            },
            {
                "speakerId": 3023962
            }
        ],
        "externalId": "6ZYEvv1SK7FD0",
        "title": "Hospitality's Response to Climate Change",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 740,
        "endMinute": 760,
        "descriptionHtml": "<p><a href=\"https://youtu.be/84ltNuieTlE\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "locationId": 60851,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1105821
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388497
                ]
            },
            {
                "id": 64995,
                "tags": [
                    388115
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3035549,
                "role": "Moderator"
            },
            {
                "speakerId": 3038643
            },
            {
                "speakerId": 3025802
            },
            {
                "speakerId": 3010638
            },
            {
                "speakerId": 3022161
            }
        ],
        "externalId": "22jhN1k1e2R22",
        "title": "The Realities of  Setting Up and Operating in Saudi – Things that You Need to Consider  ",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 825,
        "endMinute": 855,
        "descriptionHtml": "<p><a href=\"https://youtu.be/wF0415ug2kA\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1131559
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2990242
            }
        ],
        "externalId": "lSkDcfjVjICmM",
        "title": "FHS-AHIC 2023 Launch Announcement",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 780,
        "endMinute": 785,
        "descriptionHtml": "<p><a href=\"https://youtu.be/EqJULtxF-bc\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-09T00:00:00.000+0000",
        "endDate": "2023-05-09T23:59:59.000+0000",
        "id": 1145796
    },
    {
        "filters": [
            {
                "id": 64994,
                "tags": [
                    388496
                ]
            },
            {
                "id": 64995,
                "tags": [
                    389592
                ]
            }
        ],
        "description": "Click here to watch online.",
        "private": false,
        "speakers": [
            {
                "speakerId": 2906047
            }
        ],
        "externalId": "daBd7Q3khguzG",
        "title": "Using CGI and Metaverse Enabled Immersive Technologies to Drive Investment Returns for the Hospitality Sector",
        "hidden": false,
        "registrationFull": false,
        "startMinute": 980,
        "endMinute": 995,
        "descriptionHtml": "<p><a href=\"https://f.io/CajleN40\" rel=\"noopener noreferrer\" target=\"_blank\">Click here to watch online.</a></p>",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "startDate": "2023-05-08T00:00:00.000+0000",
        "endDate": "2023-05-08T23:59:59.000+0000",
        "id": 1074855
    }
]